import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

declare var jQuery:any;
declare var $ :any;
declare var defaultGridViewSettings;
declare var globalConstants;
declare var getGlobalConstantDisplay;
declare var defaultSettingsGrid;

@Component({
  selector: 'account-groups-h',
  templateUrl: './account-groups-h.component.html',
  styleUrls: ['./account-groups-h.component.css'],
})

export class AccountGroupsHistory implements OnInit {

  constructor (private route: ActivatedRoute, private titleService: Title) { }

  ngOnInit() {

    //Set the page title
    this.titleService.setTitle("WiseRisk | Account Group Event Log");

    $(document).ready(function() {
    			// prepare the data
    			var data = [ {
    				"timestamp" : "5/5/2015 06:08:46.689",
    				"user" : "System",
    				"ipAddress" : "12.56.8.32",
    				"accountGroupID" : "8786",
    				"accountGroupCode" : "IN",
    				"displayName" : "Income"
    			}, {
    				"timestamp" : "5/5/2015 06:08:47.577",
    				"user" : "System",
    				"ipAddress" : "12.56.8.32",
    				"accountGroupID" : "6558",
    				"accountGroupCode" : "GR",
    				"displayName" : "Growth"
    			} ];

    			// initialize jqxGrid
    			var source = {
    				localdata : data,
    				datafields : [ {
    					name : 'timestamp',
    					type : 'string'
    				}, {
    					name : 'user',
    					type : 'string'
    				}, {
    					name : 'ipAddress',
    					type : 'string'
    				}, {
    					name : 'accountGroupID',
    					type : 'string'
    				}, {
    					name : 'accountGroupCode',
    					type : 'string'
    				}, {
    					name : 'displayName',
    					type : 'string'
    				} ]
    			};
    			var settings = defaultGridViewSettings("#jqxgrid", source);
    			settings.columns = [ {
    				text : 'Timestamp',
    				columntype : 'textbox',
    				datafield : 'timestamp',
    				width : '160'
    			}, {
    				text : 'User',
    				columntype : 'textbox',
    				datafield : 'user',
    				width : '100'
    			}, {
    				text : 'IP Address',
    				columntype : 'textbox',
    				datafield : 'ipAddress',
    				width : '80'
    			}, {
    				text : 'External Account Group ID',
    				columntype : 'textbox',
    				datafield : 'accountGroupID',
    				width : '180'
    			}, {
    				text : 'Account Group Code',
    				columntype : 'textbox',
    				datafield : 'accountGroupCode',
    				width : '150'
    			}, {
    				text : 'Display Name',
    				columntype : 'textbox',
    				datafield : 'displayName',
    				width : '150'
    			} ];
    			$("#jqxgrid").jqxGrid(settings);
    		});
  }
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/pages/history/account-groups-h/account-groups-h.component.ts